import React from 'react';
import { motion } from 'framer-motion';
import { Section, fadeInUp } from './ui/Section';
import { GoldButton } from './ui/GoldButton';
import { ShieldCheck, Truck, CreditCard } from 'lucide-react';
export function CTASection() {
  return <Section id="cta" className="!py-32 relative" data-id="element-1">
      {/* Background Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-dark-900 via-dark-800 to-dark-900 z-0" data-id="element-2"></div>

      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true
    }} variants={fadeInUp} className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-3">
        <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-8" data-id="element-4">
          Empieza Tu Transformación <br data-id="element-5" />
          <span className="text-gold-gradient" data-id="element-6">Hoy Mismo</span>
        </h2>

        <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-7">
          No dejes pasar la oportunidad de lucir como siempre has querido con la
          seguridad y calidad que solo una faja colombiana original puede
          ofrecerte.
        </p>

        <div className="mb-12" data-id="element-8">
          <span className="text-2xl text-gray-500 line-through mr-3" data-id="element-9">$240</span>
          <span className="text-5xl md:text-6xl font-bold text-gold-gradient" data-id="element-10">
            $68
          </span>
          <p className="text-red-400 text-sm font-semibold mt-2 uppercase tracking-wide" data-id="element-11">
            ⚡ Precio especial solo por hoy
          </p>
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-12">
          <GoldButton className="text-xl px-12 py-5 w-full md:w-auto shadow-gold-DEFAULT/30" href="https://paginaspro.com/cart/52330130637079:1" data-id="element-13">
            ¡Quiero Mi Paquete Completo!
          </GoldButton>

          <p className="text-sm text-gray-500 mt-4" data-id="element-14">
            Envío seguro y discreto a todo Estados Unidos
          </p>
          <p className="text-sm text-gold-light" data-id="element-15">
            💳 Planes de pago a cuotas disponibles en el checkout
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 border-t border-gray-800 pt-12" data-id="element-16">
          <div className="flex flex-col items-center gap-3" data-id="element-17">
            <ShieldCheck className="w-8 h-8 text-gold-DEFAULT" data-id="element-18" />
            <h4 className="text-white font-bold" data-id="element-19">Compra Segura</h4>
            <p className="text-sm text-gray-500" data-id="element-20">
              Tus datos están 100% protegidos
            </p>
          </div>
          <div className="flex flex-col items-center gap-3" data-id="element-21">
            <Truck className="w-8 h-8 text-gold-DEFAULT" data-id="element-22" />
            <h4 className="text-white font-bold" data-id="element-23">Envío Gratis</h4>
            <p className="text-sm text-gray-500" data-id="element-24">A todo Estados Unidos</p>
          </div>
          <div className="flex flex-col items-center gap-3" data-id="element-25">
            <CreditCard className="w-8 h-8 text-gold-DEFAULT" data-id="element-26" />
            <h4 className="text-white font-bold" data-id="element-27">Pago Flexible</h4>
            <p className="text-sm text-gray-500" data-id="element-28">
              Todas las tarjetas y pago a cuotas disponible en el checkout
            </p>
          </div>
        </div>
      </motion.div>
    </Section>;
}